import i18next from 'i18next'
import * as React from 'react'
import { Link } from 'widgets-for-react'
import { SVGIcon } from '../../../utils/svgicon'

type PaginationLayoutProps = {
  totalItems: number
  currentPage: number
  itemsPerPage: number
  toPage: (page: number) => string
}

export const PaginationLayout = (props: PaginationLayoutProps) => {
  const { totalItems, currentPage, toPage, itemsPerPage: perPage } = props
  const totalPages = Math.ceil(totalItems / perPage)
  if (totalPages <= 1) return <> </>
  else {
    const paginationNumbers = []
    for (
      let pageNumber = currentPage - 4;
      pageNumber < currentPage + 5;
      pageNumber++
    ) {
      if (pageNumber === currentPage)
        paginationNumbers.push(
          <>
            <li
              className="pagination__item pagination__item--current"
              aria-current="page"
              key={`page-${pageNumber + 1}`}
            >
              <span className="button--ghost pagination__link pagination__link--current">
                <span className="sr-text">{i18next.t('pagination:page')} </span>
                <span className="button__label">{pageNumber + 1}</span>
              </span>
            </li>
            {currentPage + 1 != totalPages && (
              <li
                className="pagination__item pagination__mob-only"
                aria-hidden="true"
                key="/"
              >
                <span>/</span>
              </li>
            )}
          </>
        )
      else if (pageNumber >= 0 && pageNumber < totalPages)
        paginationNumbers.push(
          <>
            <li
              className={`pagination__item${
                pageNumber + 1 == totalPages ? ' pagination__item--last' : ''
              }`}
              key={`page-${pageNumber + 1}`}
            >
              <Link
                className="button--ghost pagination__link"
                to={toPage(pageNumber)}
              >
                <span className="sr-text">{i18next.t('pagination:page')} </span>
                <span className="button__label">{pageNumber + 1}</span>
              </Link>
            </li>
          </>
        )
    }

    return (
      <nav
        className="pagination pagination--default container--m gutter--m"
        aria-label={i18next.t('a11y:navLabelPagination')}
      >
        <ul className="pagination__list">
          {currentPage > 0 ? (
            <li
              className="pagination__item pagination__item--button pagination__item--prev"
              key="prev"
            >
              <Link
                className="pagination__button button--prev"
                to={toPage(currentPage - 1)}
                title={i18next.t('pagination:previousPage')}
              >
                <span className="sr-text">
                  {i18next.t('pagination:previousPage')}
                </span>
                <SVGIcon
                  className="button__icon"
                  size={10}
                  iconId="chevron-right"
                />
              </Link>
            </li>
          ) : (
            <li
              className="pagination__item pagination__item--button pagination__item--prev"
              key="prev"
            >
              <button
                className="pagination__button button--prev"
                disabled
                title={i18next.t('pagination:previousPage')}
              >
                <span className="sr-text">
                  {i18next.t('pagination:previousPage')}
                </span>
                <SVGIcon
                  className="button__icon"
                  size={10}
                  iconId="chevron-right"
                />
              </button>
            </li>
          )}

          {currentPage > 4 && (
            <li className="pagination__item" key={`page-${1}`}>
              <Link className="button--ghost pagination__link" to={toPage(0)}>
                <span className="sr-text">{i18next.t('pagination:page')} </span>
                <span className="button__label">1</span>
              </Link>
            </li>
          )}

          {currentPage > 5 && (
            <li
              className="pagination__item pagination__item--spacer"
              aria-hidden="true"
              key="left-spacer"
            >
              <span>...</span>
            </li>
          )}

          {paginationNumbers}

          {currentPage < totalPages - 6 && (
            <li
              className="pagination__item pagination__item--spacer"
              aria-hidden="true"
              key="right-spacer"
            >
              <span>...</span>
            </li>
          )}

          {currentPage < totalPages - 5 && (
            <li
              className="pagination__item pagination__item--last"
              key={`page-${totalPages}`}
            >
              <Link
                className="button--ghost pagination__link"
                to={toPage(totalPages - 1)}
              >
                <span className="sr-text">{i18next.t('pagination:page')} </span>
                <span className="button__label">{totalPages}</span>
              </Link>
            </li>
          )}

          {currentPage < totalPages - 1 ? (
            <li
              className="pagination__item pagination__item--button pagination__item--next"
              key="next"
            >
              <Link
                className="pagination__button button--next"
                to={toPage(currentPage + 1)}
                title={i18next.t('pagination:nextPage')}
              >
                <span className="sr-text">
                  {i18next.t('pagination:nextPage')}
                </span>
                <SVGIcon
                  className="button__icon"
                  size={10}
                  iconId="chevron-right"
                />
              </Link>
            </li>
          ) : (
            <li
              className="pagination__item pagination__item--button pagination__item--next"
              key="next"
            >
              <button
                className="pagination__button button--next"
                disabled
                title={i18next.t('pagination:nextPage')}
              >
                <span className="sr-text">
                  {i18next.t('pagination:nextPage')}
                </span>
                <SVGIcon
                  className="button__icon"
                  size={10}
                  iconId="chevron-right"
                />
              </button>
            </li>
          )}
        </ul>
      </nav>
    )
  }
}
